import { fetchAuth } from '../../../shared/api/ApiService';

export interface IBillingUserAccrualSummary {
    userId: string;
    userName: string;
    email: string;
    roles: string[];
    roleDetails: Array<{id: string; code: string; name: string}>;
    balance: string;
    summary: {
        lessons: string;
        penalties: string;
        bonuses: string;
        payable: string;
        unpaid: string;
    };
}

class BillingService {
    async listWorkerAccruals(from: string, to: string, signal?: AbortSignal): Promise<IBillingUserAccrualSummary[]> {
        const response = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/billing/users/accruals/list`, {
            method: 'POST',
            body: JSON.stringify({from, to, excludeRoleCodes: ['tutor'], isArchive: false}),
            signal,
        });
        const data: {items?: IBillingUserAccrualSummary[]} = await response.json();
        return data.items ?? [];
    }
}

export const billingService = new BillingService();
